import React, { Fragment, useMemo } from 'react';
import { arrayOf, shape, string } from 'prop-types';
import { useStyle } from '@magento/venia-ui/lib/classify';
import defaultClasses from './productOptions.module.css';

const ProductOptions = props => {
    const { options = [] } = props;

    const classes = useStyle(defaultClasses, props.classes);
    const displayOptions = useMemo(
        () =>
            options.map(option => {
                let option_label, value_label;
                if (
                    option.__typename == 'SelectedBundleOption' ||
                    option.__typename == 'BundleCartItem'
                ) {
                    option_label = '';
                    value_label = `${option.values[0].quantity} × ${
                        option.values[0].label
                    }`;
                } else {
                    option_label = option.option_label;
                    value_label = option.value_label.replace(/{{.*}}/, '');
                }

                if (option_label.startsWith('__')) {
                    return;
                }

                const key = `${option_label}${value_label}`;
                return (
                    <div key={key}>
                        <dt className={classes.optionLabel}>
                            {_(option_label)}
                        </dt>
                        <dd className={classes.optionValue}>{value_label}</dd>
                    </div>
                );
            }),
        [classes.optionLabel, options]
    );

    if (displayOptions.length === 0) {
        return null;
    }

    return <dl className={classes.options}>{displayOptions}</dl>;
};

ProductOptions.propTypes = {
    options: arrayOf(
        shape({
            label: string,
            value: string
        })
    )
};

export default ProductOptions;
